import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Shift } from '../../shift';
import { Position } from '../../position';
import { PositionService } from '../../position.service';
import { PositionAssignmentsService } from '../../position-assignments.service';
import { MatDialog } from '@angular/material';
import { ConfirmComponent } from './confirm/confirm.component';
import { RemoveFsAssignmentConfirmComponent } from './remove-fs-assignment-confirm/remove-fs-assignment-confirm.component';
import { AddInspectorComponent } from '../../shifts/shift-item/add-inspector/add-inspector.component';
import { AddAgencyComponent } from './add-agency/add-agency.component';
import { DatePipe } from '@angular/common';
import { TransactionService } from '../../transaction.service';
import { ChooseActionComponent } from './choose-action/choose-action.component';
import { ShiftItemInfoComponent } from './shift-item-info/shift-item-info.component';
import { AddEmailAndPhoneComponent } from "./add-email-and-phone/add-email-and-phone.component";
import { ShiftsService } from '../../shifts.service';
import { Assignment } from 'src/app/assignment';
import { removeTimeFromWorkArea } from 'src/utils';

@Component({
  selector: 'app-shift-item',
  templateUrl: './shift-item.component.html',
  styleUrls: ['./shift-item.component.scss']
})
export class ShiftItemComponent implements OnInit {

  clickedItem: any;
  @Input() shift: Shift;
  @Input() positions: Position[];
  @Input() siteName: any;
  @Input() siteId: any;
  @Input() positionDate: any;
  @Input() isDataAvailable: boolean;
  @Input() shifts: Shift[];
  // @Input() positionDate: any = '2018-05-25';
  @Output() updated = new EventEmitter<boolean>();
  clearance = localStorage.getItem('clearance');
  req: any[] = [
    {value: 'none', viewValue: 'No special requirement'},
    {value: 'heavy', viewValue: 'Heavy'},
    {value: 'color', viewValue: 'Color'},
    {value: 'excess', viewValue: 'Excess Capacity'}
  ];
  select = this.req[0].value;
  selectedItem = [];
  workAreaInput = [];
  isStartTimeEdit = false;
  isEndTimeEdit = false;

  constructor(
    private positionService: PositionService,
    private postionAssignmentService: PositionAssignmentsService,
    public dialog: MatDialog,
    private transactionService: TransactionService,
    private shiftsService: ShiftsService,
  ) { }

  ngOnInit() {
    this.positions = this.shift.positions;
    for (const item of this.positions) {
      if (item.requirement) {
        this.select = this.req[item.requirement].value;
      } else {
        this.select = this.req[0].value;
      }
      if (item.workArea) {
        this.workAreaInput[item.id] = removeTimeFromWorkArea(item.workArea);
      }
      this.selectedItem[item.id] = this.select;
      item.isStartTimeEdit = false;
      item.isEndTimeEdit = false;
      item.startHours = item.start.split(':')[0];
      item.startMinutes = item.start.split(':')[1];
      item.endHours = item.end.split(':')[0];
      item.endMinutes = item.end.split(':')[1];
      item.loading = false;
    }
  }

  // check if there are some positions that can be forwarded
  canForwardMany = (): boolean => this.positions.some(
    ({ isOverflow, isMulti, name, isRequested, status, dataLoaded, isConfirmed }) =>
      isOverflow === 0 && isMulti === 0 && name !== 'EMPTY' && status === 1 && isRequested === 0 && dataLoaded === 1 && !isConfirmed
  )

  addPositionClicked() {
    const datePipe = new DatePipe('en');
    this.positionService.addPosition(
      this.siteId,
      datePipe.transform(this.positionDate, 'yyyy-MM-dd'),
      this.shift.name,
      this.shift.start,
      this.shift.end,
      localStorage.getItem('userFullName'),
      '0',
      0,
      ''
    ).subscribe((data: any) => {
      const id = data[0].lastId;
      // this.updated.emit(true);

      // add position
      this.positions.push({
        assignments: [],
        dataLoaded: 1,
        end: this.shift.end,
        hoverText: '',
        id,
        isConfirmed: false,
        isMulti: 0,
        isOverflow: 0,
        isRequested: 0,
        isSplitMulti: 0,
        name: 'EMPTY',
        requirement: 0,
        start: this.shift.start,
        status: 0,
        workArea: null,
        isStartTimeEdit: false,
        isEndTimeEdit: false,
        startHours: this.shift.start.split(':')[0],
        startMinutes: this.shift.start.split(':')[1],
        endHours: this.shift.end.split(':')[0],
        endMinutes: this.shift.end.split(':')[1],
        loading: false
      });
      this.selectedItem[id] = this.req[0].value; // 0

      this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.shift.name,
        'Inspector position added to the ' + this.shift.name + ' shift at ' + this.siteName)
        .subscribe((tdata) => { }
      );
    });
  }

  removePositionClicked(index: number, item: Position) {
    if (item.status === 0 && item.isMulti === 0) {
      this.removePosition(index, item.id);
    } else if (item.status === 1 && item.assignments.length === 1 && item.isOverflow === 0) {
      this.dialog
        .open(RemoveFsAssignmentConfirmComponent, {width: '200', autoFocus: true, data: {name: item.name, id: item.assignments[0].inspectorId}})
        .afterClosed()
        .subscribe(result => {
          if (result === undefined) {

          } else if (result.status === 'confirmed' ) {
            this.removeFsPositionAssignment(item, item.assignments[0]);
            this.updatePosition(item);
          }
        }
      );
    } else if (item.status === 2 && item.assignments.length === 1) {
      this.dialog
        .open(RemoveFsAssignmentConfirmComponent, {width: '200', autoFocus: true, data: {name: item.name, id: item.assignments[0].inspectorId}})
        .afterClosed()
        .subscribe(result => {
          if (result.status === 'confirmed' ) {
            this.removeFsPositionAssignment(item, item.assignments[0]);
          }
        }
      );
    } else if (item.status === 3) {
      this.removeFsPositionAssignment(item, item.assignments[0]);
    } else if (item.isOverflow === 1) {
      alert('Cannot remove overflow items');
    }
  }

  removePosition(index: number, itemId: number) {
    this.positionService.removePosition(itemId)
      .subscribe((data) => {
        this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.shift.name,
          'Position removed from the ' + this.shift.name + ' shift at ' + this.siteName)
          .subscribe((tdata) => {
          }
        );
        this.positions.splice(index, 1); // remove position at the specified index
        // this.updated.emit(true);
      }
    );
  }

  updatePosition(item) {
    this.positionService.updatePositionFilled(item.id.toString(), '0', item.start, item.end, localStorage.getItem('userFullName'))
      .subscribe((data) => {});
  }

  removeFsPositionAssignment(position: Position, assignment: Assignment) {
    this.postionAssignmentService.removeFsPositionAssignment(assignment.id)
      .subscribe((data) => {
        // this.updated.emit(true);
        let itemName = '';
        if (assignment.type === 0) {
          itemName = assignment.inspectorName;
        } else {
          itemName = assignment.agencyName;
        }

        // Empty assignments
        position.status = 0;
        position.name = 'EMPTY';
        position.assignments = [];

        this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.shift.name,
          itemName + ' removed from the ' + this.shift.name + ' shift at ' + this.siteName)
          .subscribe((tdata) => {
          }
        );
      }
    );
  }

  markCovid(index: number, id: any) {
    this.postionAssignmentService.markCovid(id)
      .subscribe((data) => {
        this.ngOnInit();
        const hasCovid = this.positions[index].assignments[0].covid === 1;
        this.positions[index].assignments[0].covid = hasCovid ? 0 : 1; // toggle them
        // this.updated.emit(true);
      });
  }

  markOnSite(index: number, id: any) {
    const item = this.positions[index];
    if (
      parseInt(this.clearance) <= -1 &&
      (item.assignments[0].inspEmail === "" || item.assignments[0].inspPhone === "")
    ) {
      this.dialog.open(AddEmailAndPhoneComponent,{
        width: '450px',
        autoFocus: true,
        data: {
          phoneNumber: item.assignments[0].inspPhone,
          email: item.assignments[0].inspEmail,
          inspectorId: item.assignments[0].inspectorId,
        }
      })
        .afterClosed()
        .subscribe(data => {
          if (data.result === "Submitted") {
            this.positions[index].assignments[0].inspEmail = data.email;
            this.positions[index].assignments[0].inspPhone = data.phoneNumber;
          }
        }
      );
    }
    this.postionAssignmentService.markOnSite(id)
      .subscribe((data) => {
        this.ngOnInit();
        const onSite = this.positions[index].assignments[0].onSite === 1;
        this.positions[index].assignments[0].onSite = onSite ? 0 : 1; // toggle them
        // this.updated.emit(true);
      });
  }

  positionClicked(index: number, item: Position) {
    /*if (this.clearance < '3') {
      return;
    }*/
    this.clickedItem = item;
    if (this.clickedItem.status === 0 && this.clearance > '2') {
      // this.launchInspectorDialog();
      this.launchChooseDialog(index);
    } else if (this.clickedItem.status === 1 && this.clickedItem.isOverflow === 0 && this.clickedItem.isRequested === 0) {
      this.launchInfoDialog();
    } else if (this.clickedItem.status === 2 && this.clearance > '2') {
      // this.launchAgencyDialog();
      this.launchChooseDialog(index);
    } else if (this.clickedItem.status === 3 && this.clearance > '2') {
      // this.launchAgencyDialog();
      this.launchChooseDialog(index);
    } else if (this.clickedItem.isMulti === 1 && this.clearance > '2') {
      this.launchAgencyDialog(index);
    } else if (this.clickedItem.isOverflow === 1 && this.clearance > '2') {
      this.launchAgencyDialog(index);
    } else if (this.clickedItem.isRequested === 1 && this.clearance > '2') {
      this.launchAgencyDialog(index);
    }
  }

  launchInfoDialog() {
    this.resetStartTimeInputs(this.clickedItem);
    this.resetEndTimeInputs(this.clickedItem);
    this.dialog.open(ShiftItemInfoComponent, {width: '450px', autoFocus: true,
    data: {info: this.clickedItem}, disableClose: true})
      .afterClosed()
      .subscribe(result => {
        this.positions = this.positions.map(position => {
          if (position.id === this.clickedItem.id) {
            return {
              ...position,
              start: result.startTime,
              end: result.endTime,
              startHours: result.startTime.split(':')[0],
              startMinutes: result.startTime.split(':')[1],
              endHours: result.endTime.split(':')[0],
              endMinutes: result.endTime.split(':')[1],
            }
          } else {
            return position;
          }
        });
      }
    );
  }

  launchChooseDialog(index: number) {
    this.dialog.open(ChooseActionComponent, { width: '450px', autoFocus: true })
      .afterClosed()
      .subscribe(result => {
        if (result === undefined) {
          // this.updated.emit(true);
        } else if (result.result === 'agencyClicked') {
          this.launchAgencyDialog(index);
        } else if (result.result === 'inspectorClicked') {
          this.launchInspectorDialog(index);
        }
        // prevent refresh on close modal
        // else {
        //   this.updated.emit(true);
        // }
      }
    );
  }

  launchInspectorDialog(index: number) {
    this.dialog.open(AddInspectorComponent, {
      width: '80%',
      autoFocus: true,
      data: {
        item: this.clickedItem,
        siteId: this.siteId,
        siteName: this.siteName,
        selectedShift: {
          ...this.shift,
          start: this.clickedItem.start,
          end: this.clickedItem.end
        }
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result === undefined) { // closing function
          this.updated.emit(true);
        } else if (result.result === 'agencyClicked') {
          this.launchAgencyDialog(index);
        } else if (result.result === 'request-inspector') {
          const { id, affiliate, name } = result.data;
          const { startTime, endTime } = result;
          this.positions[index] = {
            ...this.clickedItem,
            start: startTime || this.clickedItem.start,
            end: endTime || this.clickedItem.end,
            startHours: (startTime || this.clickedItem.start).split(':')[0],
            startMinutes: (startTime || this.clickedItem.start).split(':')[1],
            endHours: (endTime || this.clickedItem.end).split(':')[0],
            endMinutes: (endTime || this.clickedItem.end).split(':')[1],
            assignments: [{
              id: result.assignmentId,
              isRequested: 1,
              inspectorName: name,
              inspAgency: affiliate,
              inspectorId: id,
              onSite: 0,
              covid: 0,
              positionId: this.clickedItem.id
            }],
            isConfirmed: false,
            isMulti: 0,
            isOverflow: 0,
            isRequested: 1,
            isSplitMulti: 0,
            name,
            status: 1
          };
        } else if (result.result === 'confirm-inspector') {
          const { id, affiliate, name } = result.data;
          const { startTime, endTime } = result;
          this.positions[index] = {
            ...this.clickedItem,
            start: startTime || this.clickedItem.start,
            end: endTime || this.clickedItem.end,
            startHours: (startTime || this.clickedItem.start).split(':')[0],
            startMinutes: (startTime || this.clickedItem.start).split(':')[1],
            endHours: (endTime || this.clickedItem.end).split(':')[0],
            endMinutes: (endTime || this.clickedItem.end).split(':')[1],
            assignments: [{
              id: result.assignmentId,
              isRequested: 0,
              inspectorName: name,
              inspAgency: affiliate,
              inspectorId: id,
              onSite: 0,
              covid: 0,
              positionId: this.clickedItem.id
            }],
            isConfirmed: false,
            isMulti: 0,
            isOverflow: 0,
            isRequested: 0,
            isSplitMulti: 0,
            name,
            status: 1
          };
        } else if (result.result === 'update-inspector') {
          const { id, affiliate, name } = result.data;
          const { startTime, endTime } = result;
          this.positions[index] = {
            ...this.clickedItem,
            start: startTime || this.clickedItem.start,
            end: endTime || this.clickedItem.end,
            startHours: (startTime || this.clickedItem.start).split(':')[0],
            startMinutes: (startTime || this.clickedItem.start).split(':')[1],
            endHours: (endTime || this.clickedItem.end).split(':')[0],
            endMinutes: (endTime || this.clickedItem.end).split(':')[1],
            assignments: [{
              ...this.clickedItem.assignments[0],
              isRequested: 0,
              inspectorName: name,
              inspAgency: affiliate,
              inspectorId: id,
              onSite: 0,
              covid: 0
            }],
            isConfirmed: false,
            isMulti: 0,
            isOverflow: 0,
            isRequested: 0,
            isSplitMulti: 0,
            name,
            status: 1
          };
        } else {
          this.updated.emit(true);
        }
      }
    );
  }

  launchAgencyDialog(index: number) {
    this.dialog.open(AddAgencyComponent, {
      width: '80%',
      autoFocus: true,
      data: {
        item: this.clickedItem,
        siteId: this.siteId,
        siteName: this.siteName,
        selectedShift: {
          ...this.shift,
          start: this.clickedItem.start,
          end: this.clickedItem.end
        }
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result === undefined) { // closing function
          this.updated.emit(true);
        } else if (result.result === 'inspectorClicked') {
          this.launchInspectorDialog(index);
        } else if (result.result === 'update-agency') {
          const { id, name } = result.data;
          const { startTime, endTime } = result;
          this.positions[index] = {
            ...this.clickedItem,
            start: startTime || this.clickedItem.start,
            end: endTime || this.clickedItem.end,
            startHours: (startTime || this.clickedItem.start).split(':')[0],
            startMinutes: (startTime || this.clickedItem.start).split(':')[1],
            endHours: (endTime || this.clickedItem.end).split(':')[0],
            endMinutes: (endTime || this.clickedItem.end).split(':')[1],
            assignments: [{
              ...this.clickedItem.assignments[0],
              isRequested: 0,
              agencyName: name,
              agencyId: id,
              onSite: 0,
              covid: 0
            }],
            isConfirmed: false,
            isMulti: 0,
            isOverflow: 0,
            isRequested: 0,
            isSplitMulti: 0,
            name,
            status: 2
          };
        } else if (result.result === 'confirm-agency') {
          const { id, name } = result.data;
          const { startTime, endTime } = result;
          this.positions[index] = {
            ...this.clickedItem,
            start: startTime || this.clickedItem.start,
            end: endTime || this.clickedItem.end,
            startHours: (startTime || this.clickedItem.start).split(':')[0],
            startMinutes: (startTime || this.clickedItem.start).split(':')[1],
            endHours: (endTime || this.clickedItem.end).split(':')[0],
            endMinutes: (endTime || this.clickedItem.end).split(':')[1],
            assignments: [{
              id: result.assignmentId,
              isRequested: 0,
              agencyName: name,
              agencyId: id,
              onSite: 0,
              covid: 0,
              positionId: this.clickedItem.id
            }],
            isConfirmed: false,
            isMulti: 0,
            isOverflow: 0,
            isRequested: 0,
            isSplitMulti: 0,
            name,
            status: 2
          };
        } else if (result.result === 'confirm-multiple-agencies') {
          const { id, name } = result.data;
          const { startTime, endTime } = result;
          this.positions[index] = {
            ...this.clickedItem,
            start: startTime || this.clickedItem.start,
            end: endTime || this.clickedItem.end,
            startHours: (startTime || this.clickedItem.start).split(':')[0],
            startMinutes: (startTime || this.clickedItem.start).split(':')[1],
            endHours: (endTime || this.clickedItem.end).split(':')[0],
            endMinutes: (endTime || this.clickedItem.end).split(':')[1],
            assignments: [
              ...this.clickedItem.assignments,
              {
                id: result.assignmentId,
                isRequested: 0,
                agencyName: name,
                agencyId: id,
                onSite: this.clickedItem.assignments[0].onSite,
                covid: this.clickedItem.assignments[0].covid,
                positionId: this.clickedItem.id
              }
            ],
            isConfirmed: false,
            isMulti: 1,
            isOverflow: 0,
            isRequested: 0,
            isSplitMulti: 1,
            name: 'Multiple Agencies',
            status: 4
          };
        } else {
          this.updated.emit(true);
        }
      }
    );
  }

  hasSameDay(d1: Date, d2: Date): boolean {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  }

  confirmInspectorClicked(index: number, item: Position) {
    if (item.isOverflow === 1) {
      alert('Overflow items cannot be confirmed');
      return;
    } else if (item.isMulti === 1) {
      alert('Items with multiple assignments cannot be confirmed');
      return;
    } else if (item.status === 2) {
      alert('Agency items cannot be confirmed');
      return;
    }
    this.clickedItem = item;
    this.dialog.open(ConfirmComponent, {
      width: '75%',
      autoFocus: true,
      data: {
        shift: this.shift,
        shifts: this.shifts,
        isInspector: true,
        item: this.clickedItem,
        date: this.positionDate,
        startTime: this.clickedItem.start,
        endTime: this.clickedItem.end,
        source: 0,
        siteId: this.siteId,
        siteName: this.siteName
      }
    })
    .afterClosed()
    .subscribe(result => {
      if (result) {
        if (result.result !== 'cancelled') {
          this.positions[index].isConfirmed = true;
          // this.updated.emit(true);
        }
      }
    });
  }

  confirmClicked() {
    this.dialog.open(ConfirmComponent, {
      width: '75%',
      autoFocus: true,
      data: {
        shift: this.shift,
        shifts: this.shifts,
        isInspector: false,
        item: this.clickedItem,
        date: this.positionDate,
        startTime: this.shift.start,
        endTime: this.shift.end,
        source: 1,
        siteId: this.siteId
      }
    })
    .afterClosed()
    .subscribe(result => {
      if (result) {
        if (result.result !== 'cancelled') {
          // make all positions confirmed or forwarded
          this.positions = this.positions.map(position => ({
            ...position,
            isConfirmed: true
          }));
          // this.updated.emit(true);
        }
      }
    });
  }

  setRequirement(index: number, item: Position, id: any) {
    let require = 0;
    if (this.selectedItem[id] === 'heavy') {
      require = 1;
    } else if (this.selectedItem[id] === 'color') {
      require = 2;
    } else if (this.selectedItem[id] === 'excess') {
      require = 3;
    }
    this.positionService.setRequirement(item.id, require)
      .subscribe((data) => {
        this.positions[index].requirement = require;
        // this.updated.emit(true);
      });
  }

  setWorkArea(index: number, id: any, workArea: string) {
    const removedTimedWorkArea = removeTimeFromWorkArea(workArea);
    this.positionService.setWorkArea(id, removedTimedWorkArea)
    .subscribe((data) => {
      this.workAreaInput[id] = removedTimedWorkArea;
      this.positions[index].workArea = removedTimedWorkArea;
      // this.updated.emit(true);
    });
  }

  confirmRequest(item: Position) {
    this.positionService.confirmRequest(item.id)
      .subscribe((data) => {
        // this.updated.emit(true);
        item.isRequested = 0;
        item.assignments[0] = {
          ...item.assignments[0],
          isRequested: 0
        };
      });
  }

  isCovid(shift: Shift) {
    if (shift.isCovid === 1 && shift.covidId !== 0) {
      this.shiftsService.deleteValidation(shift.covidId)
      .subscribe((data) => {
        shift.isCovid = 0;
      });
    } else {
      this.shiftsService.saveValidation(this.siteId, this.positionDate.toISOString().substr(0, 10), shift.name, localStorage.getItem('userFullName'))
      .subscribe((data) => {
        shift.isCovid = 1;
      });
    }
  }

  setStartTimeEdit(item: Position, isEdit: boolean) {
    this.positions = this.positions.map(position => {
      if (position.id === item.id) {
        return {
          ...position,
          isStartTimeEdit: isEdit
        }
      } else {
        return position;
      }
    });
  }

  setPositionLoading(item: Position, loading: boolean) {
    this.positions = this.positions.map(position => {
      if (position.id === item.id) {
        return {
          ...position,
          loading,
        }
      } else {
        return position;
      }
    });
  }

  setStartTimeCheck(item: Position) {
    const start = `${this.pad(Number(item.startHours))}:${this.pad(Number(item.startMinutes))}`;
    const end = item.end;

    this.setPositionLoading(item, true);
    this.positionService.updateStartAndEndTimeForPosition(start, end, item.id)
      .subscribe(() => {
        this.positions = this.positions.map(position => {
          if (position.id === item.id) {
            return {
              ...position,
              start: `${this.pad(Number(position.startHours))}:${this.pad(Number(position.startMinutes))}`,
              isStartTimeEdit: false
            }
          } else {
            return position;
          }
        });
        this.setPositionLoading(item, false);
      },
      (error) => {
        console.log({ error })
        this.positions = this.positions.map(position => {
          if (position.id === item.id) {
            return {
              ...position,
              startHours: position.start.split(':')[0],
              startMinutes: position.start.split(':')[1],
              isStartTimeEdit: false
            }
          } else {
            return position;
          }
        });
        this.setPositionLoading(item, false);
      })
  }

  resetStartTimeInputs(item: Position) {
    this.positions = this.positions.map(position => {
      if (position.id === item.id) {
        return {
          ...position,
          isStartTimeEdit: false,
          startHours: position.start.split(':')[0],
          startMinutes: position.start.split(':')[1]
        }
      } else {
        return position;
      }
    });
  }

  onStartTimeChange(item: Position, type: 'hours' | 'minutes') {
    const value = type === 'hours'
      ? item.startHours
      : item.startMinutes;

    // Allow empty while typing
    if (value === '') return;

    // Numeric only
    if (!/^\d{1,2}$/.test(value)) {
      this.revertStartOrEndTime(item, type);
      return;
    }

    const num = Number(value);

    if (type === 'hours' && (num < 0 || num > 23)) {
      this.revertStartOrEndTime(item, type);
      return;
    }

    if (type === 'minutes' && (num < 0 || num > 59)) {
      this.revertStartOrEndTime(item, type);
      return;
    }
  }

  setEndTimeEdit(item: Position, isEdit: boolean) {
    this.positions = this.positions.map(position => {
      if (position.id === item.id) {
        return {
          ...position,
          isEndTimeEdit: isEdit
        }
      } else {
        return position;
      }
    });
  }

  setEndTimeCheck(item: Position) {
    const start = item.start;
    const end = `${this.pad(Number(item.endHours))}:${this.pad(Number(item.endMinutes))}`;

    this.setPositionLoading(item, true);
    this.positionService.updateStartAndEndTimeForPosition(start, end, item.id)
      .subscribe(() => {
        this.positions = this.positions.map(position => {
          if (position.id === item.id) {
            return {
              ...position,
              end: `${this.pad(Number(position.endHours))}:${this.pad(Number(position.endMinutes))}`,
              isEndTimeEdit: false
            }
          } else {
            return position;
          }
        });
        this.setPositionLoading(item, false);
      },
      (error) => {
        console.log({ error })
        this.positions = this.positions.map(position => {
          if (position.id === item.id) {
            return {
              ...position,
              endHours: position.end.split(':')[0],
              endMinutes: position.end.split(':')[1],
              isEndTimeEdit: false
            }
          } else {
            return position;
          }
        });
        this.setPositionLoading(item, false);
      })
  }

  resetEndTimeInputs(item: Position) {
    this.positions = this.positions.map(position => {
      if (position.id === item.id) {
        return {
          ...position,
          isEndTimeEdit: false,
          endHours: position.end.split(':')[0],
          endMinutes: position.end.split(':')[1]
        }
      } else {
        return position;
      }
    });
  }

  onEndTimeChange(item: Position, type: 'hours' | 'minutes') {
    const value = type === 'hours'
      ? item.endHours
      : item.endMinutes;

    // Allow empty while typing
    if (value === '') return;

    // Numeric only
    if (!/^\d{1,2}$/.test(value)) {
      this.revertStartOrEndTime(item, type, false);
      return;
    }

    const num = Number(value);

    if (type === 'hours' && (num < 0 || num > 23)) {
      this.revertStartOrEndTime(item, type, false);
      return;
    }

    if (type === 'minutes' && (num < 0 || num > 59)) {
      this.revertStartOrEndTime(item, type, false);
      return;
    }
  }

  private revertStartOrEndTime(item: Position, type: 'hours' | 'minutes', isStart: boolean = true) {
    const [h, m] = isStart ? item.start.split(':') : item.end.split(':');
    if (type === 'hours') {
      this.positions = this.positions.map(position => {
        if (position.id === item.id) {
          if (isStart) {
            return {
              ...position,
              startHours: h
            }
          } else {
            return {
              ...position,
              endHours: h
            }
          }
        } else {
          return position;
        }
      });
    } else {
      this.positions = this.positions.map(position => {
        if (position.id === item.id) {
          if (isStart) {
            return {
              ...position,
              startMinutes: m
            }
          } else {
            return {
              ...position,
              endMinutes: m
            }
          }
        } else {
          return position;
        }
      });
    }
  }

  private pad(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
